import { AsyncReducerParams, AsyncReducerTransformAction } from './types'

/**
 * Automates the building of a dashboard reducer for all three status of a call
 *
 * @param {String} param.key Key to use for storing the data into the store
 * @param {Object} param.types Object with the status types
 * @param {String} param.types.request Type for being used before calling the api
 * @param {String} param.types.success Type for being used When the call has succeded
 * @param {String} param.types.failure Type for being used when the call fails
 * @param {Function} param.transform Object for transforming the payload into data
 * to be stored. If takes these parameters `transform(state, { type, payload, meta })`
 */
function buildAsyncStatReducer<P = any, O = any>({ key, types, transform }: AsyncReducerParams<P, O>) {
    const { request: requestType, success: successType, failure: failureType } = types

    return (state: any, action: AsyncReducerTransformAction) => {
        const { type, payload = {}, meta = {} } = action

        // State key for storing the information
        const stateKey: string | undefined | null = typeof key === 'function' ? key(action) : key

        if (!stateKey) {
            return null
        }

        switch (type) {
            case requestType: {
                return {
                    ...state,
                    stats: {
                        ...state.stats,
                    },
                    working: {
                        ...state.working,
                        [stateKey]: true,
                    },
                }
            }
            case failureType: {
                return {
                    ...state,
                    working: {
                        ...state.working,
                        [stateKey]: false,
                    },
                }
            }
            case successType: {
                if (meta.retry) {
                    return state
                }

                const data = transform(state, { type, payload, meta })

                return {
                    ...state,
                    stats: {
                        ...state.stats,
                        [stateKey]: data,
                    },
                    working: {
                        ...state.working,
                        [stateKey]: false,
                    },
                }
            }
            default:
                return null
        }
    }
}

export default buildAsyncStatReducer
